export default __webpack_public_path__ + "static/media/image_triple_100.66187fec.svg";